//toUpperCase => toFirstUpperCase //首字母转大写其他不变
String.prototype.toFirstUpperCase = function(){
    return this.split("").map(function(v, k){
        return k===0 ? v.toUpperCase() : v
    }).join("")
}


// WEBPACK FOOTER //
// ./src/util/extends/toFirstUpperCase.js